export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || "https://speaksail-server.onrender.com"

